import { Game } from '../../../interfaces/Games.interface';
import { getGames } from '../../../services/api/getGames';
import { useQuery } from '@tanstack/react-query';

export const useGames = () => {
  const { data, isLoading, error } = useQuery<Game[], string>({
    queryKey: ['games'],
    queryFn: () => {
      return getGames();
    },
  });
  return { games: data ?? [], loading: isLoading, error };
};
